import { SVGProps } from 'react';

const SvgChart2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path stroke="#28C156" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 29.332h24" />
    <path
      stroke="#28C156"
      strokeWidth={2}
      d="M4 14.667c0-1.257 0-1.886.39-2.277C4.782 12 5.41 12 6.668 12s1.885 0 2.276.39c.39.391.39 1.02.39 2.277v8c0 1.257 0 1.885-.39 2.276s-1.02.39-2.276.39c-1.257 0-1.886 0-2.276-.39C4 24.553 4 23.923 4 22.667zM13.333 9.335c0-1.257 0-1.886.39-2.277.391-.39 1.02-.39 2.277-.39s1.886 0 2.276.39c.39.391.39 1.02.39 2.277v13.333c0 1.257 0 1.886-.39 2.276s-1.019.39-2.276.39-1.886 0-2.276-.39-.39-1.019-.39-2.276zM22.667 5.335c0-1.257 0-1.886.39-2.277.39-.39 1.02-.39 2.276-.39 1.257 0 1.886 0 2.277.39.39.391.39 1.02.39 2.277v17.333c0 1.257 0 1.886-.39 2.276-.391.39-1.02.39-2.277.39s-1.885 0-2.276-.39-.39-1.019-.39-2.276z"
    />
  </svg>
);

export default SvgChart2;
